<template>
  <div id="simple-calendar-app">
    <div class="vx-card no-scroll-content">
      <!-- <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="simpleCalendarEvents"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged"> -->
        <calendar-view
          ref="calendar"
          :displayPeriodUom="calendarView"
          :show-date="showDate"
          :events="doneTasks"
          :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
          eventBorderHeight="0px"
          eventContentHeight="1.65rem"
          class="theme-default"
          @click-event="openEditEvent"
          @drop-on-date="eventDragged">
        <div slot="header" class="mb-4">
          <div class="vx-row no-gutter">
            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
              <!-- <vs-button icon-pack="feather" icon="icon-plus" @click="promptAddNewEvent(new Date())">추가</vs-button> -->
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ monthDate }}</span>
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>
            <!-- <div class="vx-row sm:flex hidden mt-4"> -->
          <div class="vx-row sm:w-1/2 mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <!-- <div class="flex flex-wrap sm:justify-start justify-center"> -->
                <div class="flex flex-wrap sm:justify-start">
                  <div v-for="member in projectMembers" :key="member.id" class="flex items-center mr-4 mb-2">
                    <!-- <vs-checkbox type="flat" style="padding:5px;"> -->
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + member.color"></div>
                      <span style="font-size:12px; font-weight:bolder">{{ member.name }}</span>
                    <!-- </vs-checkbox> -->
                  </div>
                  <!-- <div class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                      <span>None</span>
                  </div> -->
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>
    <vs-popup v-model="activePromptEditEvent" classContent="popup-example" title="Task 보기" :active.sync="activePromptEditEvent" style="z-index:10001">
      <div class="vx-row" style="margin:10px;">
        <vs-avatar :src="photoURL" size="30px"/>
        <p style="margin:5px;">{{task.name}}</p>
      </div>
      <vs-divider/>
      <span style="margin-left:10px; font-size:12px; font-weight:bolder">Task 이름 : </span>
      <span style="font-size:12px;">{{ task.title }}</span>
      <vs-divider/>
      <span style="margin-left:10px; font-size:12px; font-weight:bolder">블로그 : </span>
      <!-- <span v-if= style="font-size:12px;">{{ task.title }}</span> -->
      <span v-if="task.pblog_id" style="font-size:12px;">{{ task.blog_title }}</span>
      <span v-if="!task.pblog_id" style="font-size:12px;">없음</span>
      <vs-divider/>
      <div class="vx-row">
        <div class="w-3/5" style="margin-left:12px; margin-top:5px;" >
          <span style="margin-left:10px;  font-size:12px; font-weight:bolder">결과 url : </span>
          <span v-if="task.url" style="font-size:12px;">{{ task.url }}</span>
          <span v-if="!task.url" style="font-size:12px;">없음</span>
        </div>
        <div class="justify-end w-1/5">
          <vs-button color="dark" type="flat" icon="icon-copy" icon-pack="feather" v-clipboard:copy="task.url" v-clipboard:success="onCopy" v-clipboard:error="onError"/>
        </div>
      </div>
      <vs-divider/>
      <vs-textarea label="설명" v-model="task.detail" style="font-family:'notokr';" disabled/><br>
      <vs-button class="w-full" @click="activePromptEditEvent=false" color="dark" type="border">확인</vs-button>
    </vs-popup>
    <!-- <vs-prompt
        class="calendar-event-dialog"
        title="일정 수정"
        accept-text= "완료"
        cancel-text = "삭제"
        button-cancel = "border"
        @cancel="closeEvent"
        :active.sync="activePromptEditEvent">
        <div class="calendar__label-container flex">
            <vs-chip style="margin-bottom:10px;" v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>
            <vs-dropdown vs-custom-content class="ml-auto my-2 cursor-pointer">
                <feather-icon icon="TagIcon" svgClasses="h-5 w-5" @click.prevent></feather-icon>
                <vs-dropdown-menu style="z-index: 200001">
                        <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                            <span>{{ label.text }}</span>
                        </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <vs-input name="event-name" v-validate="'required'" class="w-full" label-placeholder="제목" v-model="task.title"></vs-input>
        <div class="my-4">
            <small class="date-label">시작</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesFrom" name="start-date"  format="yyyy년 MMM dd일" v-model="task.startDate"></datepicker>
        </div>
        <div class="my-4">
            <small class="date-label">종료</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesTo" name="end-date"  format="yyyy년 MMM dd일" v-model="task.endDate"></datepicker>
        </div>
        <div>
          <small class="date-label">설명</small>
          <vs-textarea counter="500" label-placeholder="설명" v-model="task.detail"/>
        </div>
    </vs-prompt> -->
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
// import moduleCalendar from '@/store/calendar/moduleCalendar.js'
require("vue-simple-calendar/static/css/default.css")

import Datepicker from 'vuejs-datepicker'
import { ko, he } from "vuejs-datepicker/src/locale"

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker
  },
  data() {
    return {
      colors:['success', 'warning', 'grey', 'danger', 'primary', 'info', 'secondary'],
      showDate: new Date(),
      monthDate: null,
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',
      task:{},
      langHe: he,
      langEn: ko,
      url: '',
      calendarView: 'month',
      activePromptAddEvent: false,
      activePromptEditEvent: false,
      photoURL:'',
      calendarViewTypes: [
        {
          label: "월",
          val: "month"
        },
        {
          label: "주",
          val: "week"
        },
      ]
    }
  },
  computed: {
    doneTasks() {
      return this.$store.state.task.doneTasks
    },
    validForm() {
      return this.title != '' && this.startDate != '' && this.endDate != '' && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0 && !this.errors.has('event-url');
    },
    disabledDatesTo() {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom() {
      return { from: new Date(this.endDate) }
    },
    projectMembers() {
      return this.$store.state.task.projectMembers
    },
    // doneTasks(){
    //   return this.$store.state.task.doneTasks
    // },
    labelColor() {
      return (label) => {
        if (label == "user01") return "success"
        else if (label == "user02") return "warning"
        if (label == "user03") return "danger"
        if (label == "none") return "primary"
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    openEditEvent(event) {
      // console.log(event)
      // const e = this.$store.getters['calendar/getEvent'](event.id)
      // this.labelLocal = e.tag
      console.log(event.originalEvent)
      this.task = event.originalEvent
      this.photoURL = require("@/assets/images/portrait/small/"+ this.task.photo_url)
      // console.log(this.task)
      this.activePromptEditEvent = true
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
      this.monthDate = this.$moment(this.$refs.calendar.getIncrementedPeriod(val)).format('YYYY MM월')
    },
    clearFields() {
        this.title = this.endDate = this.url = "";
        this.id= 0;
        this.labelLocal = "none";
    },
    promptAddNewEvent(date) {
        this.disabledFrom = false;
        this.addNewEventDialog(date);
    },
    closeEvent() {
      this.activePromptEditEvent = false
    },
    eventDragged(event, date) {
      this.$store.dispatch('calendar/eventDragged', {event: event, date: date})
    },
    onCopy() {
      this.$vs.notify({
        title: 'Url이 저장되었습니다',
        // text: 'Url이 저장되었습니다',
        color: 'success'
      })
    },
    onError() {
      this.$vs.notify({
        title: 'URL 저장 실패',
        color: 'danger',
      })
    },
  },
  created() {
    this.monthDate = this.$moment(new Date()).format('YYYY MM월')
    // this.$store.dispatch("task/getDoneTask", Number(this.$route.params.projectId))
  },

}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
